export const environment = {
    backendUrl: 'https://sales-test-api.car-o-liner.se/',
    production: true,
    projectName: 'josam',
  };
  